// extracted by mini-css-extract-plugin
export var infoItem = "_ng-2";
export var title = "_ng-0";
export var value = "_ng-1";